import { OMS_TRACK_YOUR_TRUCK_PATH, OMS_ORDER_TRACKING_PATH, } from '../../constants/paths';
import { apiB2B } from '../axios-client';
export var GetTrackShipmentAPI = function (requestData) {
    var trackShipmentPayload = "?providerCode=".concat(requestData.providerCode, "&trackingNumber=").concat(requestData.trackingNumber, "&orderNumber=").concat(requestData.orderNumber);
    var TrackShipment = "".concat(OMS_ORDER_TRACKING_PATH).concat(trackShipmentPayload);
    return apiB2B.get(TrackShipment);
};
export var GetTrackYourtruckAPI = function (requestData) {
    return apiB2B.post(OMS_TRACK_YOUR_TRUCK_PATH, requestData);
};
